import { EventTypes } from '../types';
import { buildImpressionEvents } from './builders';

const { notification, encourageSellerReply } = EventTypes;

export const ImpressionEvents = {
    [notification.shown]: buildImpressionEvents('notification_is_shown'),
    [encourageSellerReply.shown]: buildImpressionEvents('encourage_seller_reply_is_shown'),
};
